import produce from 'immer'

import { IMPORT_PROFILE } from './types'

export const initialState = {
  loading: true,
  error: false,
  importProfileLoading: null,
  importProfile: null,
  statuses: null,
  logsList: [],
  columns: [],
  pages: { totalPages: 0, currentPage: 0 },
  totalItems: 0,
  errorLog: null,
  fileDownloaded: null,
  loadingDownload: false,
  loadingTableLogs: false,
  tableLogsItems: null,
  dataFilters: [],
  dataFiltersError: null,
  filterLoading: false,
  pendingProcessInfo: null
}

const reducer = (state = initialState, { type, payload }) => produce(state, draft => {
  switch (type) {
    case IMPORT_PROFILE.GET_IMPORT:
      draft.importProfileLoading = true
      break
    case IMPORT_PROFILE.GET_IMPORT_SUCCESS: {
      const { importProfile, statuses } = payload
      draft.loading = false
      draft.importProfileLoading = false
      draft.importProfile = importProfile
      draft.pendingProcessInfo = importProfile.statusId
      draft.statuses = statuses
      break
    }
    case IMPORT_PROFILE.GET_IMPORT_ERROR:
      draft.loading = false
      draft.error = payload
      break
    case IMPORT_PROFILE.GET_LOGS_ERROR:
      draft.errorLog = payload
      break
    case IMPORT_PROFILE.DOWNLOAD_FILE:
      draft.loadingDownload = true
      break
    case IMPORT_PROFILE.FILE_DOWNLOADED:
      draft.loadingDownload = false
      draft.fileDownloaded = payload
      break
    case IMPORT_PROFILE.GET_LOGS:
      draft.loadingTableLogs = true
      break
    case IMPORT_PROFILE.GET_LOGS_SUCCESS: {
      const { items, fields, totalItems, totalPages, currentPage } = payload
      draft.loadingTableLogs = false
      draft.logsList = items
      draft.columns = fields
      draft.totalItems = totalItems
      draft.pages = { totalPages, currentPage }
      break
    }
    case IMPORT_PROFILE.GET_FILTER_DATA:
      draft.filterLoading = true
      break
    case IMPORT_PROFILE.FILTER_DATA_SUCCESS:
      draft.dataFilters = payload
      draft.filterLoading = false
      break
    case IMPORT_PROFILE.FILTER_DATA_ERROR:
      draft.dataFiltersError = payload
      draft.filterLoading = false
      break
    case IMPORT_PROFILE.FILTER_DATA_CLEAR:
      draft.dataFilters = []
      draft.dataFiltersError = null
      draft.filterLoading = false
      break
    case IMPORT_PROFILE.CLEAR_PENDING_PROCESS_INFO:
      draft.pendingProcessInfo = null
      break
    case IMPORT_PROFILE.CLEAR:
      return initialState
    default:
      return initialState
  }
})

export default reducer
